import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import company from 'assets/img/company.png'
import people from 'assets/img/people.png'
import mmbox from 'assets/img/htbox1.png'
import Map from 'containers/Maps/Map'
import React from 'react'

const map = <Map
  isDesktop
  showMapButton={false}
/>

const StaticContent: React.FC = () => {
  const { t } = useTranslation('onePage')
  const { push } = useHistory()
  return (
    <>
      <div className='onePage__section__wrapper --secTheme'>
        <div className='onePage__section'>
          <div className='onePage__section__content'>
            <h3>{t('selfStorageForIndividuals.header')}</h3>
            <h1>{t('selfStorageForIndividuals.title')}</h1>
            <p>{t('selfStorageForIndividuals.desc')}</p>
            <p>{t('selfStorageForIndividuals.desc2')}</p>
            <BackBtn
              text={t('findStorage')}
              action={() => {
                push('/map')
              }}
            />
          </div>
          <div className='onePage__section__img'>
            <img
              alt=''
              src={people}
            />
          </div>
        </div>
      </div>

      <div className='onePage__section__wrapper'>
        <div className='onePage__section'>
          <div className='onePage__section__img'>
            <img
              alt=''
              src={company}
            />
          </div>
          <div className='onePage__section__content'>
            <h3>{t('selfStorageForBusinesses.header')}</h3>
            <h1>{t('selfStorageForBusinesses.title')}</h1>
            <p>{t('selfStorageForBusinesses.desc')}</p>
            <p>{t('selfStorageForBusinesses.desc2')}</p>
            <BackBtn
              text={t('selfStorage')}
              action={() => {
                push('/map')
              }}
            />
          </div>
        </div>
      </div>

      <div className='onePage__map'>
        <div className='onePage__map__sizes'>
          <div className='onePage__map__sizes__top'>
            <img
              alt='storage'
              className='--htbox'
              src={mmbox}
            />
            <div className='onePage__map__sizes__content'>
              <h1 className='--bigger'>{t('whichStorageShouldYouChoose')}</h1>
              <h3>{t('whichStorageShouldYouChooseDesc')}</h3>
              <BackBtn
                text={t('rentStorage')}
                action={() => {
                  push('/map')
                }}
              />
            </div>
          </div>
          <div className='onePage__map__sizes__bottom'>
            <div className='onePage__map__sizes__bottom__item'>
              <h1>{t('upTo')} 7m<sup>2</sup></h1>
              <h3>{t('smallStorageDescription')}</h3>
            </div>
            <div className='onePage__map__sizes__bottom__item'>
              <h1>7m<sup>2</sup> - 12m<sup>2</sup></h1>
              <h3>{t('mediumStorageDescription')}</h3>
            </div>
            <div className='onePage__map__sizes__bottom__item'>
              <h1>{t('above')} 12m<sup>2</sup></h1>
              <h3>{t('largeStorageDescription')}</h3>
            </div>
          </div>
        </div>

        <div className='onePage__map__label'>
          <h3>{t('findStorage')}</h3>
          <h1>{t('useMap')}</h1>
          {map}
        </div>
      </div>
    </>
  )
}

export default StaticContent